import React, { useState, useEffect, useRef } from 'react';
import { host_url } from '../../App'; // Import host_url
import axios from 'axios';
import { CAMP_TAGE, aktuellerCampTag } from '../../campTage';
import KernteamLayout from '../../KernteamLayout';
import BackArrow from '../../BackArrow';
import '../ListenSubpage.css';
import './DienstplaenePage.css';

// Dienst-Typen, durch die man sich durchklickt. Jeder Typ bestimmt selbst,
// welche Folge-Optionen nötig sind und wie sich die Uhrzeit ergibt.
const TYP_SPUELDIENST = 'Spueldienst';
const TYP_NACHTWACHE = 'Nachtwache';
const TYP_FREITEXT = 'Freitext';

// Mahlzeiten für den Spüldienst. Die Uhrzeit wird automatisch gesetzt
// (identisch zu den Essenszeiten im Speiseplan), aber weiterhin angezeigt.
const MAHLZEITEN = [
  { key: 'Fruehstueck', label: 'Frühstück', icon: 'bakery_dining',  uhrzeit: '07:30' },
  { key: 'Mittag',      label: 'Mittag',    icon: 'lunch_dining',   uhrzeit: '12:00' },
  { key: 'Abend',       label: 'Abend',     icon: 'dinner_dining',  uhrzeit: '18:00' },
];

const NACHTWACHE_UHRZEIT = '22:00';

function DienstplaenePage() {
  const [successMsg, setSuccessMsg] = useState('');
  const [teamer, setTeamer] = useState('');
  const [bereich, setBereich] = useState('');
  const [typ, setTyp] = useState(TYP_SPUELDIENST);
  const [tag, setTag] = useState(aktuellerCampTag());
  const [mahlzeit, setMahlzeit] = useState(MAHLZEITEN[0].key);
  const [freitextDienst, setFreitextDienst] = useState('');
  const [freitextUhrzeit, setFreitextUhrzeit] = useState('');
  const [entries, setEntries] = useState([]);
  const [limit, setLimit] = useState(5);

  const teamerRef = useRef(null);
  const erfolgTimer = useRef(null);

  const ladeEintraege = async () => {
    try {
      const res = await fetch(`${host_url}/dienstplaene`);
      const data = await res.json();
      if (Array.isArray(data)) setEntries(data);
    } catch (err) {
      console.error('Error fetching dienstplaene:', err);
    }
  };

  useEffect(() => {
    ladeEintraege();
    return () => clearTimeout(erfolgTimer.current);
  }, []);

  // Berechnet aus dem gewählten Typ + Optionen die Werte, die gespeichert
  // werden (Dienst-Bezeichnung, Datum, Uhrzeit). Die Datenbank-Struktur
  // bleibt unverändert – wir leiten die Felder nur automatisch ab.
  const aktuelleMahlzeit = MAHLZEITEN.find(m => m.key === mahlzeit) || MAHLZEITEN[0];

  const baueEintrag = () => {
    if (typ === TYP_SPUELDIENST) {
      return {
        Dienst: `Spüldienst ${aktuelleMahlzeit.label}`,
        Datum: tag,
        Uhrzeit: aktuelleMahlzeit.uhrzeit,
      };
    }
    if (typ === TYP_NACHTWACHE) {
      return { Dienst: 'Nachtwache', Datum: tag, Uhrzeit: NACHTWACHE_UHRZEIT };
    }
    // Freitext
    return { Dienst: freitextDienst.trim(), Datum: tag, Uhrzeit: freitextUhrzeit };
  };

  // Die Uhrzeit, die wir dem Nutzer anzeigen (automatisch bzw. frei eingegeben).
  const angezeigteUhrzeit =
    typ === TYP_SPUELDIENST ? aktuelleMahlzeit.uhrzeit
    : typ === TYP_NACHTWACHE ? NACHTWACHE_UHRZEIT
    : freitextUhrzeit;

  const isFormValid =
    teamer.trim() &&
    bereich &&
    tag &&
    (typ !== TYP_FREITEXT || (freitextDienst.trim() && freitextUhrzeit));

  const zeigeErfolg = (text) => {
    setSuccessMsg(text);
    clearTimeout(erfolgTimer.current);
    erfolgTimer.current = setTimeout(() => setSuccessMsg(''), 2500);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid) return;
    const eintrag = baueEintrag();
    try {
      await axios.post(`${host_url}/dienstplaene`, {
        Teamer: teamer.trim(),
        Bereich: bereich,
        ...eintrag,
      });
      zeigeErfolg(`${eintrag.Dienst} für ${teamer.trim()} eingetragen`);
      // Für schnelles Eintragen mehrerer Personen hintereinander bleiben Typ,
      // Tag und Mahlzeit/Uhrzeit erhalten – nur der Name wird geleert und
      // bekommt direkt wieder den Fokus.
      setTeamer('');
      teamerRef.current?.focus();
      ladeEintraege();
    } catch (error) {
      console.error('Fehler beim Hinzufügen des Dienstplans:', error);
      alert('Fehler beim Hinzufügen des Dienstplans');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Eintrag wirklich löschen?')) return;
    try {
      await fetch(`${host_url}/dienstplaene/${id}`, { method: 'DELETE' });
      setEntries(prev => prev.filter(e => e.ID !== id));
    } catch (error) {
      console.error('Fehler beim Löschen des Dienstplans:', error);
      alert('Fehler beim Löschen des Dienstplans');
    }
  };

  const TYPEN = [
    { key: TYP_SPUELDIENST, label: 'Spüldienst', icon: 'wash' },
    { key: TYP_NACHTWACHE,  label: 'Nachtwache', icon: 'bedtime' },
    { key: TYP_FREITEXT,    label: 'Freitext',   icon: 'edit' },
  ];

  return (
    <KernteamLayout>
    <div className="container">
      <BackArrow to="/listen" />
      <h1 className="section-title blue">Einsatz im Dienstplan eintragen</h1>

      {successMsg && (
        <div className="dp-toast">
          <span className="material-symbols-outlined">check_circle</span>
          {successMsg}
        </div>
      )}

      <form onSubmit={handleSubmit} className="dienstplaene-form">
        <div className="form-group">
          <label>Name</label>
          <input
            ref={teamerRef}
            type="text"
            placeholder="Gib den Namen des Teamers/der Teamerin ein"
            value={teamer}
            onChange={(e) => setTeamer(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label>Bereich</label>
          <div className={`dropdown-wrapper ${bereich ? 'filled' : ''}`}>
            <select value={bereich} onChange={(e) => setBereich(e.target.value)} required>
              <option value="" disabled>Bereich wählen</option>
              <option value="Zeltbetreuung">Zeltbetreuung</option>
              <option value="Arbeit/Freizeit">Arbeit/Freizeit</option>
              <option value="Logistik">Logistik</option>
              <option value="Parlament">Parlament</option>
            </select>
            <span className="dropdown-plus material-symbols-outlined">keyboard_arrow_down</span>
          </div>
        </div>

        {/* Dienst-Typ: durchklickbare Auswahl */}
        <div className="form-group">
          <label>Dienst</label>
          <div className="dp-typ-row">
            {TYPEN.map(t => (
              <button
                type="button"
                key={t.key}
                className={`dp-typ-btn ${typ === t.key ? 'active' : ''}`}
                onClick={() => setTyp(t.key)}
              >
                <span className="material-symbols-outlined">{t.icon}</span>
                {t.label}
              </button>
            ))}
          </div>
        </div>

        {/* Tag – für alle Typen identisch */}
        <div className="form-group">
          <label>Tag</label>
          <div className="dp-tag-row">
            {CAMP_TAGE.map(t => (
              <button
                type="button"
                key={t.datum}
                className={`dp-pill ${tag === t.datum ? 'active' : ''}`}
                onClick={() => setTag(t.datum)}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        {/* Mahlzeit – nur für Spüldienst */}
        {typ === TYP_SPUELDIENST && (
          <div className="form-group">
            <label>Mahlzeit</label>
            <div className="dp-mahlzeit-row">
              {MAHLZEITEN.map(m => (
                <button
                  type="button"
                  key={m.key}
                  className={`dp-mahlzeit-btn ${mahlzeit === m.key ? 'active' : ''}`}
                  onClick={() => setMahlzeit(m.key)}
                >
                  <span className="material-symbols-outlined">{m.icon}</span>
                  {m.label}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Freitext – eigener Dienstname + freie Uhrzeit */}
        {typ === TYP_FREITEXT && (
          <>
            <div className="form-group">
              <label>Bezeichnung</label>
              <input
                type="text"
                placeholder="Gib die Bezeichnung des Diensts ein"
                value={freitextDienst}
                onChange={(e) => setFreitextDienst(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>Uhrzeit</label>
              <input
                type="time"
                value={freitextUhrzeit}
                onChange={(e) => setFreitextUhrzeit(e.target.value)}
                required
              />
            </div>
          </>
        )}

        {/* Automatisch gesetzte Uhrzeit (Spüldienst / Nachtwache) anzeigen */}
        {typ !== TYP_FREITEXT && (
          <div className="dp-uhrzeit-info">
            <span className="material-symbols-outlined">schedule</span>
            <span>Uhrzeit: <strong>{angezeigteUhrzeit} Uhr</strong> (automatisch)</span>
          </div>
        )}

        <button type="submit" disabled={!isFormValid}>Hinzufügen</button>
      </form>

      <div className="ci-table-wrapper">
        <table className="ci-table">
          <thead>
            <tr>
              <th>Datum</th>
              <th>Uhrzeit</th>
              <th>Dienst</th>
              <th>Name</th>
              <th>Bereich</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {entries
              .slice()
              .sort((a, b) => b.ID - a.ID)
              .slice(0, limit)
              .map(entry => (
                <tr key={entry.ID}>
                  <td>{new Date(entry.Datum).toLocaleDateString('de-DE')}</td>
                  <td>{entry.Uhrzeit ? entry.Uhrzeit.substring(0,5) : ''}</td>
                  <td>{entry.Dienst}</td>
                  <td>{entry.Teamer}</td>
                  <td>{entry.Bereich}</td>
                  <td>
                    <a href="#" onClick={(e) => { e.preventDefault(); handleDelete(entry.ID); }}>
                      <span className="material-symbols-outlined delete-icon">delete</span>
                    </a>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        {limit < entries.length && (
          <div className="more-strip">
            <a href="#" className="more-link" onClick={(e) => { e.preventDefault(); setLimit(prev => prev + 5); }}>
              Mehr anzeigen
            </a>
          </div>
        )}
      </div>
    </div>
    </KernteamLayout>
  );
}

export default DienstplaenePage;
